import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import PortfolioPage from "./pages/PortfolioPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ProjectConsultationPage from "./pages/ProjectConsultationPage";
import ProjectEstimatorPage from "./pages/ProjectEstimatorPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminProjectsPage from "./pages/AdminProjectsPage";
import AdminEditProjectPage from "./pages/AdminEditProjectPage";
import AdminVendorsPage from "./pages/AdminVendorsPage";
import AdminEmploymentPage from "./pages/AdminEmploymentPage";
import AdminJobsPage from "./pages/AdminJobsPage";
import AdminContactPage from "./pages/AdminContactPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminEstimatorPage from "./pages/AdminEstimatorPage";
import AdminTestimonialsPage from "./pages/AdminTestimonialsPage";
import AdminServicesPage from "./pages/AdminServicesPage";
import AdminFaqPage from "./pages/AdminFaqPage";
import AdminPhonePage from "./pages/AdminPhonePage";
import AdminStandardsPage from "./pages/AdminStandardsPage";
import AdminRolesPage from "./pages/AdminRolesPage";
import AdminContentStudioPage from "./pages/AdminContentStudioPage";
import AdminKnowledgeBasePage from "./pages/AdminKnowledgeBasePage";
import AdminSeoPage from "./pages/AdminSeoPage";
import BillPayPage from "./pages/BillPayPage";
import CashFlowPage from "./pages/CashFlowPage";
import PlansPage from "./pages/PlansPage";
import AdminPlansPage from "./pages/AdminPlansPage";
import LocationPage from "./pages/LocationPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import FaqPage from "./pages/FaqPage";
import StandardsPage from "./pages/StandardsPage";
import AcceptInvitePage from "./pages/AcceptInvitePage";
import JobTreadPage from "./pages/JobTreadPage";
import VendorApplicationPage from "./pages/VendorApplicationPage";
import EmploymentApplicationPage from "./pages/EmploymentApplicationPage";
import CareersPage from "./pages/CareersPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SEO from "./components/SEO";
import ChatWidget from "./components/ChatWidget";
import { Toaster } from "./components/ui/sonner";

// Router component with SEO
function AppRouter() {
  return (
    <>
      <SEO />
      <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/portfolio/:slug" element={<ProjectDetailPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/consultation" element={<ProjectConsultationPage />} />
      <Route path="/estimator" element={<ProjectEstimatorPage />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/locations/:slug" element={<LocationPage />} />
      <Route path="/jobtread" element={<JobTreadPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/careers/:jobSlug" element={<CareersPage />} />
      <Route path="/vendor-application" element={<VendorApplicationPage />} />
      <Route path="/employment-application" element={<EmploymentApplicationPage />} />
      <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/admin/projects" element={<AdminProjectsPage />} />
      <Route path="/admin/projects/:projectId" element={<AdminEditProjectPage />} />
      <Route path="/admin/vendors" element={<AdminVendorsPage />} />
      <Route path="/admin/employment" element={<AdminEmploymentPage />} />
      <Route path="/admin/jobs" element={<AdminJobsPage />} />
      <Route path="/admin/contact" element={<AdminContactPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/estimator" element={<AdminEstimatorPage />} />
      <Route path="/admin/testimonials" element={<AdminTestimonialsPage />} />
      <Route path="/admin/services" element={<AdminServicesPage />} />
      <Route path="/admin/faq" element={<AdminFaqPage />} />
      <Route path="/admin/phone" element={<AdminPhonePage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/standards" element={<StandardsPage />} />
      <Route path="/standards/:categorySlug" element={<StandardsPage />} />
      <Route path="/standards/:categorySlug/:sectionSlug" element={<StandardsPage />} />
      <Route path="/admin/standards" element={<AdminStandardsPage />} />
      <Route path="/admin/plans" element={<AdminPlansPage />} />
      <Route path="/admin/roles" element={<AdminRolesPage />} />
      <Route path="/admin/content" element={<AdminContentStudioPage />} />
      <Route path="/admin/knowledge-base" element={<AdminKnowledgeBasePage />} />
      <Route path="/admin/billpay" element={<BillPayPage />} />
      <Route path="/admin/cashflow" element={<CashFlowPage />} />
      <Route path="/admin/seo" element={<AdminSeoPage />} />
      <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
      <Route path="/knowledge-base/:articleSlug" element={<KnowledgeBasePage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <ChatWidget />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
